import * as u from './utils';

export default () => {
    const scrollableDiv = document.querySelector('.archive-head__cateories');
    const scrollRightButton = document.querySelector('.archive-head__scroll');
    let autoScrollTimeout;
    let scrollToLeftAnimationId;
    let scrollToRightAnimationId;
    let lastTimestamp = 0;
    let isUserScrolling = false;

    if (!scrollableDiv) {
        return;
    }

    const autoScrollToLeft = () => {
        const targetScrollLeft = 0;
        const scrollSpeed = 0.7; // pixels per millisecond

        // Cancel any existing animations
        if (scrollToLeftAnimationId) {
            cancelAnimationFrame(scrollToLeftAnimationId);
        }

        const animateScrollLeft = (timestamp) => {
            if (!lastTimestamp) lastTimestamp = timestamp;
            const deltaTime = timestamp - lastTimestamp;
            lastTimestamp = timestamp;

            if (scrollableDiv.scrollLeft > targetScrollLeft) {
                const step = scrollSpeed * deltaTime;
                scrollableDiv.scrollLeft -= step;
                scrollToLeftAnimationId = requestAnimationFrame(animateScrollLeft);
            }
        };

        scrollToLeftAnimationId = requestAnimationFrame(animateScrollLeft);
    };

    const getDistanceToScrollToNext = () => {
        const scrollableDivRect = scrollableDiv.getBoundingClientRect();

        for (const child of scrollableDiv.children) {
            const childRect = child.getBoundingClientRect();
            if (childRect.right > scrollableDivRect.right) {
                return childRect.right - scrollableDivRect.right;
            }
        }

        return 0;
    };

    const scrollToNextLink = () => {
        const distance = getDistanceToScrollToNext();
        const scrollTarget = scrollableDiv.scrollLeft + distance;
        const scrollSpeed = 0.5; // pixels per millisecond

        if (distance < 10) {
            autoScrollTimeout = setTimeout(() => {
                lastTimestamp = 0;
                autoScrollToLeft();
            }, 2500);

            return;
        }

        // Cancel any existing animations
        if (scrollToRightAnimationId) {
            cancelAnimationFrame(scrollToRightAnimationId);
        }

        const animateScrollRight = (timestamp) => {
            if (!lastTimestamp) lastTimestamp = timestamp;
            const deltaTime = timestamp - lastTimestamp;
            lastTimestamp = timestamp;

            if (scrollableDiv.scrollLeft < scrollTarget) {
                const step = scrollSpeed * deltaTime;
                scrollableDiv.scrollLeft += step;
                scrollToRightAnimationId = requestAnimationFrame(animateScrollRight);
            } else {
                autoScrollTimeout = setTimeout(() => {
                    lastTimestamp = 0;
                    autoScrollToLeft();
                }, 2500);
            }
        };

        scrollToRightAnimationId = requestAnimationFrame(animateScrollRight);
    };

    scrollRightButton.addEventListener('click', () => {
        clearTimeout(autoScrollTimeout);

        // Cancel any existing animations
        if (scrollToLeftAnimationId) {
            cancelAnimationFrame(scrollToLeftAnimationId);
        }
        if (scrollToRightAnimationId) {
            cancelAnimationFrame(scrollToRightAnimationId);
        }

        lastTimestamp = 0;
        scrollToNextLink();
    });

    scrollableDiv.addEventListener('touchstart', () => {
        isUserScrolling = true;
        clearTimeout(autoScrollTimeout);

        // Cancel any existing animations
        if (scrollToLeftAnimationId) {
            cancelAnimationFrame(scrollToLeftAnimationId);
        }
        if (scrollToRightAnimationId) {
            cancelAnimationFrame(scrollToRightAnimationId);
        }
    });

    scrollableDiv.addEventListener('touchend', () => {
        isUserScrolling = false;
        autoScrollTimeout = setTimeout(() => {
            lastTimestamp = 0;
            autoScrollToLeft();
        }, 2500);
    });

    scrollableDiv.addEventListener('touchmove', () => {
        if (isUserScrolling) {
            clearTimeout(autoScrollTimeout);
        }
    });

    const handleResize = () => {
        if (scrollableDiv.scrollWidth > scrollableDiv.clientWidth) {
            u.addClass(scrollRightButton, 'is-active');
        } else {
            u.removeClass(scrollRightButton, 'is-active');
        }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
};
